module.exports = __webpack_public_path__ + "static/media/QR_iuxlabsoa.68753e3a.png";